/**
 * Spark 3DGS integration for Potree.
 *
 * Public surface (re-exported to `Potree.Spark` via src/Potree.js):
 *   - loadGaussianSplat(viewer, source, options)  — one-shot loader
 *   - reloadGaussianSplats(viewer, override)      — rebuild loaded splats (e.g. extSplats)
 *   - disposeSparkRenderer(viewer)                — full teardown (fixes geometry leak)
 *   - getSparkRenderer(viewer, options)           — shared SparkRenderer
 *   - getSpark()                                  — full spark module namespace
 *   - load()                                      — bare loader (alias of getSpark)
 *   - isLoaded()                                  — probe
 *   - exportClippedGaussianSplats(viewer, options) — 按裁剪体积筛选并导出 splat (.splat/.ply)
 */
export { loadGaussianSplat, reloadGaussianSplats, disposeSparkRenderer, getSpark, getSparkRenderer } from "./PotreeSparkAdapter.js";
export { load, isLoaded } from "./SparkLoader.js";
export { exportClippedGaussianSplats } from "./SplatClipExport.js";
